'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var localizedFields = ['FORMAT', 'STATUS', 'BRANCH', 'PRIMARY_LANGUAGE', 'LANGUAGE', 'FICTION_TYPE', 'CIRC', 'TECHNICAL_DIFFICULTY', 'UGC_RATING', 'NEWLY_ACQUIRED', 'AUDIENCE', 'ON_ORDER'];

var conjunctiveFields = ['NEWLY_ACQUIRED', 'FICTION_TYPE', 'GEO_HEADINGS', 'GENRE_HEADINGS', 'TOPIC_HEADINGS', 'AUTHOR', 'PUBLISHED_DATE', 'UGC_RATING', 'TECHNICAL_DIFFICULTY', 'TAG_GENRE', 'TAG_TONE', 'TAG_ABOUT', 'TAG_PERSONAL'];

var isConjunctiveField = exports.isConjunctiveField = function isConjunctiveField(fieldId) {
  return conjunctiveFields.indexOf(fieldId) >= 0;
};

var getLabel = exports.getLabel = function getLabel(intl, id, value) {
  var singleBranch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (id === 'STATUS' && value === '_anywhere_' && singleBranch) {
    // Override for single branch libraries
    return intl.formatMessage({ id: 'STATUS.field' });
  }

  if (localizedFields.indexOf(id) === -1) {
    return value;
  }

  if (id === 'PRIMARY_LANGUAGE') {
    return intl.formatMessage({ id: 'LANGUAGE.' + value.toLowerCase(), defaultMessage: value }) || value;
  }

  return intl.formatMessage({ id: id + '.' + value.toLowerCase(), defaultMessage: value }) || value;
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-filter/lib/index.js
// module id = 179
// module chunks = 1